var map = {
	"./artifact.png": "2f14",
	"./artifact_attunement.png": "956f",
	"./artifact_attunement_image.png": "3f27",
	"./artifact_decor_image.png": "ae31",
	"./artifact_image.png": "e249",
	"./base.jpg": "b1aa",
	"./base2.jpg": "396d",
	"./base_back.jpg": "7453",
	"./common.png": "fce7",
	"./common_attunement.png": "b4d4",
	"./common_attunement_image.png": "dacb",
	"./common_image.png": "6aa11",
	"./dagger_1.png": "fac6",
	"./dummy.png": "84f9",
	"./eg_logo_gold.png": "c455",
	"./eg_logo_white.png": "8de0",
	"./eventyr_logo.png": "5f4b",
	"./hero_dragon.jpg": "d3c9",
	"./hero_items.jpg": "4e40",
	"./hero_npcs.jpg": "ea2f",
	"./hero_ooze.jpg": "e07a",
	"./item_images/armor/heavy_armor_1.png": "66e7",
	"./item_images/armor/heavy_armor_2.png": "be15",
	"./item_images/armor/heavy_armor_3.png": "c331",
	"./item_images/armor/heavy_armor_4.png": "e39e",
	"./item_images/armor/heavy_armor_5.png": "6f10",
	"./item_images/armor/heavy_armor_6.png": "2447",
	"./item_images/armor/light_armor_1.png": "f809",
	"./item_images/armor/light_armor_2.png": "0797",
	"./item_images/armor/light_armor_3.png": "730b",
	"./item_images/armor/light_armor_4.png": "dd14",
	"./item_images/armor/light_armor_5.png": "804a",
	"./item_images/armor/light_armor_6.png": "a359",
	"./item_images/armor/light_armor_7.png": "09ec",
	"./item_images/armor/medium_armor_1.png": "08c0",
	"./item_images/armor/medium_armor_2.png": "b0e6",
	"./item_images/armor/medium_armor_3.png": "8d31",
	"./item_images/armor/medium_armor_4.png": "a413",
	"./item_images/armor/medium_armor_5.png": "ceee",
	"./item_images/armor/medium_armor_6.png": "3feb",
	"./item_images/armor/medium_armor_7.png": "cb7a",
	"./item_images/armor/shield_1.png": "5cfc",
	"./item_images/armor/shield_2.png": "66eb",
	"./item_images/armor/shield_3.png": "308b",
	"./item_images/armor/shield_4.png": "41e4",
	"./item_images/armor/shield_5.png": "06d1",
	"./item_images/armor/shield_6.png": "d9eb",
	"./item_images/dummy.png": "3459",
	"./item_images/potion/potion_1.png": "120c",
	"./item_images/potion/potion_10.png": "3fd0",
	"./item_images/potion/potion_11.png": "62da",
	"./item_images/potion/potion_12.png": "80b8",
	"./item_images/potion/potion_13.png": "9c5c",
	"./item_images/potion/potion_14.png": "3cc1",
	"./item_images/potion/potion_15.png": "f96f",
	"./item_images/potion/potion_16.png": "6979",
	"./item_images/potion/potion_17.png": "7c98",
	"./item_images/potion/potion_18.png": "f608",
	"./item_images/potion/potion_19.png": "35e1",
	"./item_images/potion/potion_2.png": "3e0e",
	"./item_images/potion/potion_20.png": "645e",
	"./item_images/potion/potion_21.png": "0e1e",
	"./item_images/potion/potion_22.png": "d4f9",
	"./item_images/potion/potion_23.png": "a39b",
	"./item_images/potion/potion_24.png": "3d96",
	"./item_images/potion/potion_25.png": "36fc",
	"./item_images/potion/potion_3.png": "5ef2",
	"./item_images/potion/potion_4.png": "ce92",
	"./item_images/potion/potion_5.png": "f1ab",
	"./item_images/potion/potion_6.png": "e2b2",
	"./item_images/potion/potion_7.png": "9217",
	"./item_images/potion/potion_8.png": "835b",
	"./item_images/potion/potion_9.png": "f9ec",
	"./item_images/ring/ring_1.png": "6198",
	"./item_images/ring/ring_2.png": "a4d7",
	"./item_images/ring/ring_3.png": "b9f3",
	"./item_images/ring/ring_4.png": "678e",
	"./item_images/ring/ring_5.png": "0056",
	"./item_images/ring/ring_6.png": "bc2e",
	"./item_images/ring/ring_7.png": "1fdb",
	"./item_images/ring/ring_8.png": "624e",
	"./item_images/rod_staff_wand/rod_1.png": "1a14",
	"./item_images/rod_staff_wand/rod_2.png": "bf77",
	"./item_images/rod_staff_wand/staff_1.png": "0567",
	"./item_images/rod_staff_wand/staff_2.png": "5f5b",
	"./item_images/rod_staff_wand/staff_3.png": "ae42",
	"./item_images/rod_staff_wand/staff_4.png": "1ba7",
	"./item_images/rod_staff_wand/wand_1.png": "ab5c",
	"./item_images/rod_staff_wand/wand_2.png": "2c9d",
	"./item_images/rod_staff_wand/wand_3.png": "a7e4",
	"./item_images/rod_staff_wand/wand_4.png": "a149",
	"./item_images/rod_staff_wand/wand_5.png": "43ab",
	"./item_images/rod_staff_wand/wand_6.png": "1188",
	"./item_images/rod_staff_wand/wand_7.png": "105f",
	"./item_images/scroll/scroll_1.png": "a8d8",
	"./item_images/scroll/scroll_2.png": "048a",
	"./item_images/weapon/axe_1.png": "4723",
	"./item_images/weapon/axe_2.png": "92d7",
	"./item_images/weapon/axe_3.png": "b3bd",
	"./item_images/weapon/axe_4.png": "47fc",
	"./item_images/weapon/axe_5.png": "57b2",
	"./item_images/weapon/axe_6.png": "d44e5",
	"./item_images/weapon/bow_1.png": "4259",
	"./item_images/weapon/bow_2.png": "f675",
	"./item_images/weapon/bow_3.png": "ffd6",
	"./item_images/weapon/bow_4.png": "08292",
	"./item_images/weapon/bow_5.png": "5ebd",
	"./item_images/weapon/bow_6.png": "37e1",
	"./item_images/weapon/bow_7.png": "5346",
	"./item_images/weapon/bow_8.png": "18fd",
	"./item_images/weapon/club_1.png": "39aa",
	"./item_images/weapon/club_2.png": "5bdd",
	"./item_images/weapon/crossbow_1.png": "c424",
	"./item_images/weapon/crossbow_2.png": "25ba",
	"./item_images/weapon/dagger_1.png": "a658",
	"./item_images/weapon/dagger_2.png": "ba00",
	"./item_images/weapon/dagger_3.png": "a093",
	"./item_images/weapon/dagger_4.png": "3831",
	"./item_images/weapon/dagger_5.png": "e262",
	"./item_images/weapon/dagger_6.png": "d2a5",
	"./item_images/weapon/dart_1.png": "3f69",
	"./item_images/weapon/dart_2.png": "5646",
	"./item_images/weapon/flail_1.png": "0393",
	"./item_images/weapon/hammer_1.png": "2bfa",
	"./item_images/weapon/hammer_2.png": "9007",
	"./item_images/weapon/maul_1.png": "438a",
	"./item_images/weapon/morningstar_1.png": "316b",
	"./item_images/weapon/polearm_1.png": "d0c7",
	"./item_images/weapon/polearm_2.png": "f915",
	"./item_images/weapon/polearm_3.png": "9445",
	"./item_images/weapon/quarterstaff_1.png": "b456",
	"./item_images/weapon/quarterstaff_2.png": "f006",
	"./item_images/weapon/scythe_1.png": "35ff",
	"./item_images/weapon/sickle_1.png": "1517",
	"./item_images/weapon/sickle_2.png": "8ef1",
	"./item_images/weapon/sickle_3.png": "5cae",
	"./item_images/weapon/sickle_4.png": "f43b",
	"./item_images/weapon/sling_1.png": "04f9",
	"./item_images/weapon/spear_1.png": "aa31",
	"./item_images/weapon/spear_2.png": "c2d3",
	"./item_images/weapon/spear_3.png": "a3aa",
	"./item_images/weapon/sword_1.png": "b192",
	"./item_images/weapon/sword_10.png": "a015",
	"./item_images/weapon/sword_11.png": "e84d",
	"./item_images/weapon/sword_12.png": "4e8f",
	"./item_images/weapon/sword_13.png": "f92e",
	"./item_images/weapon/sword_14.png": "6f0f",
	"./item_images/weapon/sword_15.png": "e673",
	"./item_images/weapon/sword_2.png": "6de2",
	"./item_images/weapon/sword_3.png": "4539",
	"./item_images/weapon/sword_4.png": "749e",
	"./item_images/weapon/sword_5.png": "7f0b",
	"./item_images/weapon/sword_6.png": "d144",
	"./item_images/weapon/sword_7.png": "1323",
	"./item_images/weapon/sword_8.png": "bbe2",
	"./item_images/weapon/sword_9.png": "7c69",
	"./item_images/weapon/trident_1.png": "931f",
	"./item_images/weapon/whip_1.png": "8270",
	"./item_images/wondrous_item/amulet_1.png": "1a83",
	"./item_images/wondrous_item/amulet_2.png": "384b",
	"./item_images/wondrous_item/amulet_3.png": "8670",
	"./item_images/wondrous_item/amulet_4.png": "a01b",
	"./item_images/wondrous_item/amulet_5.png": "0e01",
	"./item_images/wondrous_item/amulet_6.png": "ee4d",
	"./item_images/wondrous_item/belt_1.png": "c087",
	"./item_images/wondrous_item/belt_10.png": "a426",
	"./item_images/wondrous_item/belt_11.png": "b371",
	"./item_images/wondrous_item/belt_12.png": "7238",
	"./item_images/wondrous_item/belt_2.png": "926b",
	"./item_images/wondrous_item/belt_3.png": "b1df",
	"./item_images/wondrous_item/belt_4.png": "d9e3",
	"./item_images/wondrous_item/belt_5.png": "5038",
	"./item_images/wondrous_item/belt_6.png": "2fcb",
	"./item_images/wondrous_item/belt_7.png": "6d93",
	"./item_images/wondrous_item/belt_8.png": "5ae2",
	"./item_images/wondrous_item/belt_9.png": "28ec",
	"./item_images/wondrous_item/book_1.png": "57be",
	"./item_images/wondrous_item/book_2.png": "c217",
	"./item_images/wondrous_item/book_3.png": "98d1",
	"./item_images/wondrous_item/book_4.png": "4ca7",
	"./item_images/wondrous_item/book_5.png": "d797",
	"./item_images/wondrous_item/boots_1.png": "137f",
	"./item_images/wondrous_item/boots_10.png": "6879",
	"./item_images/wondrous_item/boots_11.png": "c32e",
	"./item_images/wondrous_item/boots_12.png": "1025",
	"./item_images/wondrous_item/boots_2.png": "0210",
	"./item_images/wondrous_item/boots_3.png": "6582",
	"./item_images/wondrous_item/boots_4.png": "cb8f",
	"./item_images/wondrous_item/boots_5.png": "6aa1",
	"./item_images/wondrous_item/boots_6.png": "6205",
	"./item_images/wondrous_item/boots_7.png": "232b",
	"./item_images/wondrous_item/boots_8.png": "ca9d",
	"./item_images/wondrous_item/boots_9.png": "62cb",
	"./item_images/wondrous_item/bracers_1.png": "6b9a",
	"./item_images/wondrous_item/bracers_10.png": "262a",
	"./item_images/wondrous_item/bracers_11.png": "5d8c",
	"./item_images/wondrous_item/bracers_12.png": "5431",
	"./item_images/wondrous_item/bracers_13.png": "3253",
	"./item_images/wondrous_item/bracers_14.png": "b887",
	"./item_images/wondrous_item/bracers_15.png": "7c31",
	"./item_images/wondrous_item/bracers_16.png": "0ccf",
	"./item_images/wondrous_item/bracers_17.png": "a4bf",
	"./item_images/wondrous_item/bracers_18.png": "e710",
	"./item_images/wondrous_item/bracers_19.png": "909f",
	"./item_images/wondrous_item/bracers_2.png": "3b44",
	"./item_images/wondrous_item/bracers_3.png": "3254",
	"./item_images/wondrous_item/bracers_4.png": "cbfb",
	"./item_images/wondrous_item/bracers_5.png": "db62",
	"./item_images/wondrous_item/bracers_6.png": "af14",
	"./item_images/wondrous_item/bracers_7.png": "0f41",
	"./item_images/wondrous_item/bracers_8.png": "5d2e",
	"./item_images/wondrous_item/bracers_9.png": "1a29",
	"./item_images/wondrous_item/cloak_1.png": "0198",
	"./item_images/wondrous_item/cloak_2.png": "ee7a",
	"./item_images/wondrous_item/cloak_3.png": "a679",
	"./item_images/wondrous_item/cloak_4.png": "261c",
	"./item_images/wondrous_item/compass_1.png": "4a11",
	"./item_images/wondrous_item/cowl_1.png": "d8e6",
	"./item_images/wondrous_item/flute_1.png": "0c04",
	"./item_images/wondrous_item/gauntlets_1.png": "6865",
	"./item_images/wondrous_item/gauntlets_2.png": "0fb2",
	"./item_images/wondrous_item/gauntlets_3.png": "b9c5",
	"./item_images/wondrous_item/gauntlets_4.png": "adb9",
	"./item_images/wondrous_item/gem.png": "1698",
	"./item_images/wondrous_item/gem_1.png": "acd3",
	"./item_images/wondrous_item/hat_1.png": "094c",
	"./item_images/wondrous_item/hat_2.png": "86d7",
	"./item_images/wondrous_item/headdress_1.png": "aeae",
	"./item_images/wondrous_item/helmet_1.png": "1dff",
	"./item_images/wondrous_item/helmet_2.png": "1ee4",
	"./item_images/wondrous_item/helmet_3.png": "19de",
	"./item_images/wondrous_item/helmet_4.png": "edfd",
	"./item_images/wondrous_item/helmet_5.png": "0b76",
	"./item_images/wondrous_item/helmet_6.png": "5f54",
	"./item_images/wondrous_item/hood_1.png": "ecb5",
	"./item_images/wondrous_item/incense_1.png": "2937",
	"./item_images/wondrous_item/mask_1.png": "0463",
	"./item_images/wondrous_item/mirror_1.png": "41b2",
	"./item_images/wondrous_item/mirror_2.png": "99b0",
	"./item_images/wondrous_item/tattoo_1.png": "adf5",
	"./item_images/wondrous_item/tattoo_2.png": "3462",
	"./item_images/wondrous_item/tattoo_3.png": "15b4",
	"./item_images/wondrous_item/tattoo_4.png": "7757",
	"./item_images/wondrous_item/tattoo_5.png": "853d",
	"./item_images/wondrous_item/tattoo_6.png": "6e11",
	"./item_images/wondrous_item/tattoo_7.png": "98c3",
	"./item_images/wondrous_item/tattoo_8.png": "0c4f",
	"./legendary.png": "997e",
	"./legendary_attunement.png": "bd80",
	"./legendary_attunement_image.png": "2d0b",
	"./legendary_decor_image.png": "c018",
	"./legendary_image.png": "df3b",
	"./npc_images/M1.png": "8463",
	"./npc_images/M2.png": "5349",
	"./npc_images/M3.png": "2a9e",
	"./npc_images/dragonborn_1.png": "30bb",
	"./npc_images/dragonborn_2.png": "2a62b",
	"./npc_images/dwarf_1.png": "ef11",
	"./npc_images/dwarf_10.png": "3f0e",
	"./npc_images/dwarf_11.png": "f8d5",
	"./npc_images/dwarf_12.png": "8a85",
	"./npc_images/dwarf_13.png": "3140",
	"./npc_images/dwarf_14.png": "cf8a",
	"./npc_images/dwarf_15.png": "4af0",
	"./npc_images/dwarf_16.png": "9c2b",
	"./npc_images/dwarf_17.png": "7a5d",
	"./npc_images/dwarf_18.png": "7765",
	"./npc_images/dwarf_19.png": "de7c",
	"./npc_images/dwarf_2.png": "1db3",
	"./npc_images/dwarf_20.png": "36ae",
	"./npc_images/dwarf_21.png": "5633",
	"./npc_images/dwarf_22.png": "fd07",
	"./npc_images/dwarf_23.png": "49d4",
	"./npc_images/dwarf_24.png": "ee88",
	"./npc_images/dwarf_25.png": "a78b",
	"./npc_images/dwarf_26.png": "6748",
	"./npc_images/dwarf_27.png": "1e8e",
	"./npc_images/dwarf_28.png": "e205",
	"./npc_images/dwarf_29.png": "443a",
	"./npc_images/dwarf_3.png": "e796",
	"./npc_images/dwarf_4.png": "d938",
	"./npc_images/dwarf_5.png": "4179",
	"./npc_images/dwarf_6.png": "2275",
	"./npc_images/dwarf_7.png": "b104",
	"./npc_images/dwarf_8.png": "8f3a",
	"./npc_images/dwarf_9.png": "88e2",
	"./npc_images/elemental_1.png": "e29c",
	"./npc_images/elemental_2.png": "757e",
	"./npc_images/elemental_3.png": "e3e4",
	"./npc_images/elemental_4.png": "625f",
	"./npc_images/elf_1.png": "9f2e",
	"./npc_images/elf_10.png": "a5a3",
	"./npc_images/elf_11.png": "80a5",
	"./npc_images/elf_12.png": "1bb5",
	"./npc_images/elf_13.png": "9460",
	"./npc_images/elf_14.png": "28fb",
	"./npc_images/elf_15.png": "d6be",
	"./npc_images/elf_16.png": "f595",
	"./npc_images/elf_17.png": "86d2",
	"./npc_images/elf_18.png": "3d37",
	"./npc_images/elf_19.png": "d7fe",
	"./npc_images/elf_2.png": "4563",
	"./npc_images/elf_20.png": "f1ae",
	"./npc_images/elf_21.png": "bb6f",
	"./npc_images/elf_22.png": "7e04",
	"./npc_images/elf_23.png": "3a60",
	"./npc_images/elf_24.png": "9db7",
	"./npc_images/elf_25.png": "5b38",
	"./npc_images/elf_26.png": "716f",
	"./npc_images/elf_27.png": "475c",
	"./npc_images/elf_28.png": "47bd",
	"./npc_images/elf_29.png": "e5ec",
	"./npc_images/elf_3.png": "f54a",
	"./npc_images/elf_30.png": "ef51",
	"./npc_images/elf_31.png": "2ffb",
	"./npc_images/elf_4.png": "c344",
	"./npc_images/elf_5.png": "a628",
	"./npc_images/elf_6.png": "9ec4",
	"./npc_images/elf_7.png": "479b",
	"./npc_images/elf_8.png": "09e3",
	"./npc_images/elf_9.png": "2dd1",
	"./npc_images/fey_1.png": "2156",
	"./npc_images/fey_2.png": "12dd",
	"./npc_images/fey_3.png": "cbbb",
	"./npc_images/fey_4.png": "1b79",
	"./npc_images/fey_5.png": "65b3",
	"./npc_images/fiend_1.png": "4aa0",
	"./npc_images/fiend_2.png": "9d84",
	"./npc_images/fiend_3.png": "4da2",
	"./npc_images/fiend_4.png": "c1f2",
	"./npc_images/giant_1.png": "865a",
	"./npc_images/gnoll_1.png": "a6f3",
	"./npc_images/gnoll_2.png": "7763",
	"./npc_images/gnoll_3.png": "536e",
	"./npc_images/gnoll_4.png": "8219",
	"./npc_images/gnome_1.png": "3ef5",
	"./npc_images/gnome_2.png": "7905",
	"./npc_images/gnome_3.png": "c547",
	"./npc_images/gnome_4.png": "84a5",
	"./npc_images/gnome_5.png": "c4de",
	"./npc_images/gnome_6.png": "9531",
	"./npc_images/gnome_7.png": "8197",
	"./npc_images/gnome_8.png": "d60e",
	"./npc_images/goblin_1.png": "b918",
	"./npc_images/goblin_2.png": "de88",
	"./npc_images/goblin_3.png": "cc00",
	"./npc_images/goblin_4.png": "229b",
	"./npc_images/goblin_5.png": "dd00",
	"./npc_images/goblin_6.png": "26e1",
	"./npc_images/golem_1.png": "c2ef",
	"./npc_images/halfling_1.png": "0402",
	"./npc_images/halfling_10.png": "5d71",
	"./npc_images/halfling_11.png": "5553",
	"./npc_images/halfling_13.png": "0cb8",
	"./npc_images/halfling_14.png": "b061",
	"./npc_images/halfling_15.png": "ade4",
	"./npc_images/halfling_16.png": "7400",
	"./npc_images/halfling_17.png": "af6a",
	"./npc_images/halfling_18.png": "2681",
	"./npc_images/halfling_19.png": "e504",
	"./npc_images/halfling_2.png": "dcf3",
	"./npc_images/halfling_20.png": "676e",
	"./npc_images/halfling_21.png": "bf3b",
	"./npc_images/halfling_22.png": "70e9",
	"./npc_images/halfling_3.png": "f4cb",
	"./npc_images/halfling_4.png": "f34a",
	"./npc_images/halfling_5.png": "da7a",
	"./npc_images/halfling_6.png": "dd51",
	"./npc_images/halfling_7.png": "2840",
	"./npc_images/halfling_8.png": "dbc0",
	"./npc_images/halfling_9.png": "9113",
	"./npc_images/human_1.png": "8612",
	"./npc_images/human_10.png": "6232",
	"./npc_images/human_11.png": "db08",
	"./npc_images/human_12.png": "d57e",
	"./npc_images/human_13.png": "f48c",
	"./npc_images/human_14.png": "5eff",
	"./npc_images/human_15.png": "d702",
	"./npc_images/human_16.png": "e390",
	"./npc_images/human_17.png": "d671",
	"./npc_images/human_19.png": "bd89",
	"./npc_images/human_2.png": "4325",
	"./npc_images/human_20.png": "7a45",
	"./npc_images/human_21.png": "e465",
	"./npc_images/human_22.png": "560f",
	"./npc_images/human_23.png": "3860",
	"./npc_images/human_24.png": "f2f4",
	"./npc_images/human_25.png": "299d",
	"./npc_images/human_26.png": "41ac",
	"./npc_images/human_27.png": "18c5",
	"./npc_images/human_28.png": "aa8e",
	"./npc_images/human_29.png": "decc",
	"./npc_images/human_3.png": "a921",
	"./npc_images/human_30.png": "65da",
	"./npc_images/human_31.png": "eadd",
	"./npc_images/human_32.png": "0a54",
	"./npc_images/human_33.png": "5b64",
	"./npc_images/human_34.png": "469a",
	"./npc_images/human_35.png": "ecb0",
	"./npc_images/human_36.png": "4b4a",
	"./npc_images/human_37.png": "fb1b",
	"./npc_images/human_38.png": "26f8",
	"./npc_images/human_39.png": "2577",
	"./npc_images/human_4.png": "7af0",
	"./npc_images/human_40.png": "c825",
	"./npc_images/human_41.png": "ec6b",
	"./npc_images/human_42.png": "d98a",
	"./npc_images/human_43.png": "fb37",
	"./npc_images/human_44.png": "d5fd",
	"./npc_images/human_45.png": "7b4b",
	"./npc_images/human_46.png": "fcc3",
	"./npc_images/human_47.png": "1cb7",
	"./npc_images/human_48.png": "5f02",
	"./npc_images/human_49.png": "6ad0",
	"./npc_images/human_5.png": "af30",
	"./npc_images/human_50.png": "7e75",
	"./npc_images/human_51.png": "ce08",
	"./npc_images/human_52.png": "692a",
	"./npc_images/human_53.png": "30bf",
	"./npc_images/human_54.png": "f224",
	"./npc_images/human_55.png": "ef88",
	"./npc_images/human_56.png": "c12d",
	"./npc_images/human_57.png": "3a6d",
	"./npc_images/human_58.png": "0456",
	"./npc_images/human_59.png": "25b7",
	"./npc_images/human_6.png": "133c",
	"./npc_images/human_60.png": "6ab2",
	"./npc_images/human_61.png": "002b",
	"./npc_images/human_62.png": "a819",
	"./npc_images/human_63.png": "fc6c",
	"./npc_images/human_64.png": "02ab",
	"./npc_images/human_65.png": "7450",
	"./npc_images/human_66.png": "c558",
	"./npc_images/human_67.png": "6d18",
	"./npc_images/human_68.png": "0694",
	"./npc_images/human_69.png": "f18d",
	"./npc_images/human_7.png": "b9ab",
	"./npc_images/human_70.png": "56f4",
	"./npc_images/human_71.png": "b66c",
	"./npc_images/human_72.png": "2d0c",
	"./npc_images/human_73.png": "0c66",
	"./npc_images/human_74.png": "6837",
	"./npc_images/human_75.png": "f626",
	"./npc_images/human_76.png": "9f1a",
	"./npc_images/human_77.png": "cc7b",
	"./npc_images/human_78.png": "8b20",
	"./npc_images/human_79.png": "6cf4",
	"./npc_images/human_8.png": "6fab",
	"./npc_images/human_80.png": "f1c0",
	"./npc_images/human_81.png": "8dd0",
	"./npc_images/human_82.png": "6d1a",
	"./npc_images/human_83.png": "64f4",
	"./npc_images/human_84.png": "3c9f",
	"./npc_images/human_85.png": "1ee8",
	"./npc_images/human_86.png": "bf26",
	"./npc_images/human_87.png": "412a",
	"./npc_images/human_9.png": "81b9",
	"./npc_images/kobold_1.png": "3d91",
	"./npc_images/medusa_1.png": "a639",
	"./npc_images/minotaur_1.png": "3988",
	"./npc_images/minotaur_2.png": "95f6",
	"./npc_images/minotaur_3.png": "37f0",
	"./npc_images/ogre_1.png": "38a7",
	"./npc_images/orc_1.png": "75ac",
	"./npc_images/orc_10.png": "d59d",
	"./npc_images/orc_11.png": "1ef6",
	"./npc_images/orc_12.png": "1cf7",
	"./npc_images/orc_2.png": "fb7f",
	"./npc_images/orc_3.png": "1ec9",
	"./npc_images/orc_4.png": "7cb8",
	"./npc_images/orc_5.png": "5f67",
	"./npc_images/orc_6.png": "98ad",
	"./npc_images/orc_7.png": "1195",
	"./npc_images/orc_8.png": "e588",
	"./npc_images/orc_9.png": "e597",
	"./npc_images/placeholder.png": "0ccb",
	"./npc_images/tiefling_1.png": "c0a9",
	"./npc_images/tiefling_2.png": "70f1",
	"./npc_images/tiefling_3.png": "162e",
	"./npc_images/tiefling_4.png": "550b",
	"./npc_images/tiefling_6.png": "e863",
	"./npc_images/undead_1.png": "35eb",
	"./npc_images/undead_2.png": "b5dd",
	"./npc_images/undead_3.png": "945d",
	"./npc_images/undead_4.png": "2703",
	"./npc_images/undead_5.png": "67cb",
	"./npc_images/werebear_1.png": "0c49",
	"./npc_images/werebear_2.png": "63da",
	"./npc_images/werebear_3.png": "9c17",
	"./npc_images/wererat_1.png": "fc45",
	"./npc_images/wererat_2.png": "1417",
	"./npc_images/werewolf_1.png": "3429",
	"./patreon.png": "0f5a",
	"./rare.png": "cad5",
	"./rare_attunement.png": "158f",
	"./rare_attunement_image.png": "44b7",
	"./rare_decor_image.png": "3d69",
	"./rare_image.png": "8708",
	"./shop_images/alchemistlab_1.png": "679c",
	"./shop_images/alchemistlab_2.png": "0e09",
	"./shop_images/alchemistlab_3.png": "6f61",
	"./shop_images/blacksmith_1.png": "7f6e",
	"./shop_images/blacksmith_2.png": "ae61",
	"./shop_images/blacksmith_3.png": "6587",
	"./shop_images/blacksmith_4.png": "3b54",
	"./shop_images/blacksmith_5.png": "c72f",
	"./shop_images/blacksmith_6.png": "6c38",
	"./shop_images/blacksmith_7.png": "aec8",
	"./shop_images/castle_1.png": "eff2",
	"./shop_images/castle_2.png": "de2d",
	"./shop_images/castle_3.png": "db19",
	"./shop_images/city_1.png": "e851",
	"./shop_images/city_2.png": "383d",
	"./shop_images/city_3.png": "1231",
	"./shop_images/city_4.png": "9b82",
	"./shop_images/city_5.png": "35fe",
	"./shop_images/forest_1.png": "f702",
	"./shop_images/garden_1.png": "4d66",
	"./shop_images/garden_2.png": "4ce4",
	"./shop_images/garden_3.png": "9e66",
	"./shop_images/garden_4.png": "5cbd",
	"./shop_images/garden_5.png": "29d7",
	"./shop_images/garden_6.png": "f23e",
	"./shop_images/garden_7.png": "302a",
	"./shop_images/garden_8.png": "cec2",
	"./shop_images/garden_9.png": "cffd",
	"./shop_images/guildhall_1.png": "c058",
	"./shop_images/guildhall_2.png": "76ff",
	"./shop_images/house_1.png": "07ea",
	"./shop_images/house_2.png": "9fe3",
	"./shop_images/house_3.png": "4659",
	"./shop_images/house_4.png": "fc5f",
	"./shop_images/house_5.png": "46cd",
	"./shop_images/house_6.png": "5f80",
	"./shop_images/house_7.png": "7372",
	"./shop_images/house_8.png": "9adc",
	"./shop_images/house_9.png": "bf3a",
	"./shop_images/hut_1.png": "b787",
	"./shop_images/market_1.png": "5c8b",
	"./shop_images/market_2.png": "78b1",
	"./shop_images/market_3.png": "2bc1",
	"./shop_images/market_4.png": "7042",
	"./shop_images/market_5.png": "2218",
	"./shop_images/market_6.png": "87ee",
	"./shop_images/placeholder.png": "7aa4",
	"./shop_images/ship_1.png": "79a6",
	"./shop_images/ship_2.png": "ccbb",
	"./shop_images/ship_3.png": "68b7",
	"./shop_images/ship_4.png": "a2b9",
	"./shop_images/ship_5.png": "9da6",
	"./shop_images/ship_6.png": "7668",
	"./shop_images/ship_7.png": "866a",
	"./shop_images/ship_8.png": "e1b0",
	"./shop_images/shop_1.png": "262a4",
	"./shop_images/shop_2.png": "e1d8",
	"./shop_images/shop_3.png": "ec50",
	"./shop_images/shop_4.png": "1e98",
	"./shop_images/shop_5.png": "2c1d",
	"./shop_images/temple_1.png": "1de4",
	"./shop_images/temple_2.png": "a3d3",
	"./shop_images/tower_1.png": "cbcb",
	"./shop_images/tower_2.png": "5395",
	"./shop_images/tower_3.png": "1a4b",
	"./shop_images/treehouse_1.png": "e2e1",
	"./shop_images/treehouse_2.png": "29cd",
	"./shop_images/treehouse_3.png": "d8d0",
	"./shop_images/treehouse_4.png": "d15a",
	"./shop_images/treehouse_5.png": "5d66",
	"./shop_images/treehouse_6.png": "80bf",
	"./shop_images/treehouse_7.png": "7ff4",
	"./shop_images/treehouse_8.png": "b487",
	"./shop_images/vault_1.png": "d17d",
	"./shop_images/vault_2.png": "7d5c",
	"./shop_images/wagon_1.png": "8f31",
	"./shop_images/wagon_2.png": "ed49",
	"./texture1.jpg": "9552",
	"./uncommon.png": "3d1b",
	"./uncommon_attunement.png": "3c2e",
	"./uncommon_attunement_image.png": "84d9",
	"./uncommon_image.png": "9a04",
	"./very_rare.png": "7d53",
	"./very_rare_attunement.png": "5980",
	"./very_rare_attunement_image.png": "93c7",
	"./very_rare_decor_image.png": "bd73",
	"./very_rare_image.png": "aac5",
	"./withImage.jpg": "34e9",
	"./withImage.png": "eab1",
	"./withImage2.jpg": "63b9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";